import { AccessCodes } from '@pm2/api';
import { extractComponentExcerpt } from './util.extract-component-excerpt.js';

function parsePm2Data(node, caption) {
  const accessCode = parseInt(node.getAttribute("access") ?? "0", 10) || AccessCodes.ALLOWED;
  const isScrambled = !!(accessCode & AccessCodes.AUTHENTICATION_REQUIRED || accessCode & AccessCodes.LICENSE_REQUIRED);
  if (accessCode !== AccessCodes.ALLOWED && !isScrambled) {
    return void 0;
  }
  return {
    ...extractLearningObject(node, caption),
    ...extractToolbarButtons(node),
    ...extractPdfConfig(node),
    // by default elements are considered not to contain a transcript, this
    // will need to be custom implemented on a per-element basis
    transcript: void 0,
    speechFileUrl: node.getAttribute("audioReferenceId") || void 0,
    ribbonIconId: void 0,
    // only text-components now support ribbons, and they custom-implement logic for it
    isScrambled
  };
}
function extractLearningObject(node, caption) {
  return {
    learningObjectId: node.getAttribute("id") || void 0,
    learningObjectTitle: node.getAttribute("learningTitle") || node.getAttribute("title") || extractComponentExcerpt(node, caption)
  };
}
function extractToolbarButtons(node) {
  return {
    enableLightboxButton: node.getAttribute("showOpenInReader") === "true" || node.getAttribute("openInLightbox") === "true",
    enableNewWindowButton: node.getAttribute("showOpenInNewWindow") === "true",
    enableNotebookButton: node.getAttribute("showNotebook") === "true"
  };
}
function extractPdfConfig(node) {
  return {
    pdfFileUrl: node.getAttribute("pdfFile") ? `${process.env["PM2_MEDIA_DOMAIN"]}/${node.getAttribute("pdfFile")}` : void 0,
    pdfExport: {
      headerImage: node.getAttribute("pdfHeaderImage") ? `${process.env["PM2_MEDIA_DOMAIN"]}/${node.getAttribute(
        "pdfHeaderImage"
      )}` : void 0,
      lineCount: node.getAttribute("lineCounter") === "true",
      template: extractPdfTemplate(node)
    }
  };
}
function extractPdfTemplate(node) {
  const template = node.getAttribute("format");
  if (template === null) {
    return "book";
  }
  switch (template.toLowerCase()) {
    case "article":
      return "article";
    case "book":
      return "book";
    case "booksprog":
      return "book-language";
    case "sourcetext":
      return "source";
    case "munksgaard":
      return "munksgaard";
    case "hansreitzel":
      return "hans-reitzel";
    default:
      if (node.getAttribute("showOpenAsPdf") === "true" && !node.getAttribute("pdfFile")) {
        console.warn(
          `extractPdfTemplate(...): Unknown PDF template "${node.getAttribute("format")}".`
        );
      }
      return "book";
  }
}

export { parsePm2Data };
//# sourceMappingURL=util.parse-pm2-data.js.map
